export const countries = [
  {
    countryCode: "AF",
    tokens: "AF Afghanistan",
    value: "Afghanistan",
    name: "Afghanistan",
  },
  {
    countryCode: "AX",
    tokens: "AX Åland Islands",
    value: "Åland Islands",
    name: "Åland Islands",
  },
  {
    countryCode: "AL",
    tokens: "AL Albania",
    value: "Albania",
    name: "Albania",
  },
  {
    countryCode: "DZ",
    tokens: "DZ Algeria",
    value: "Algeria",
    name: "Algeria",
  },
  {
    countryCode: "AS",
    tokens: "AS American Samoa",
    value: "American Samoa",
    name: "American Samoa",
  },
  {
    countryCode: "AD",
    tokens: "AD Andorra",
    value: "Andorra",
    name: "Andorra",
  },
  { countryCode: "AO", tokens: "AO Angola", value: "Angola", name: "Angola" },
  {
    countryCode: "AI",
    tokens: "AI Anguilla",
    value: "Anguilla",
    name: "Anguilla",
  },
  {
    countryCode: "AQ",
    tokens: "AQ Antarctica",
    value: "Antarctica",
    name: "Antarctica",
  },
  {
    countryCode: "AG",
    tokens: "AG Antigua and Barbuda",
    value: "Antigua and Barbuda",
    name: "Antigua and Barbuda",
  },
  {
    countryCode: "AR",
    tokens: "AR Argentina",
    value: "Argentina",
    name: "Argentina",
  },
  {
    countryCode: "AM",
    tokens: "AM Armenia",
    value: "Armenia",
    name: "Armenia",
  },
  { countryCode: "AW", tokens: "AW Aruba", value: "Aruba", name: "Aruba" },
  {
    countryCode: "AU",
    tokens: "AU Australia",
    value: "Australia",
    name: "Australia",
  },
  {
    countryCode: "AT",
    tokens: "AT Austria",
    value: "Austria",
    name: "Austria",
  },
  {
    countryCode: "AZ",
    tokens: "AZ Azerbaijan",
    value: "Azerbaijan",
    name: "Azerbaijan",
  },
  {
    countryCode: "BS",
    tokens: "BS Bahamas",
    value: "Bahamas",
    name: "Bahamas",
  },
  {
    countryCode: "BH",
    tokens: "BH Bahrain",
    value: "Bahrain",
    name: "Bahrain",
  },
  {
    countryCode: "BD",
    tokens: "BD Bangladesh",
    value: "Bangladesh",
    name: "Bangladesh",
  },
  {
    countryCode: "BB",
    tokens: "BB Barbados",
    value: "Barbados",
    name: "Barbados",
  },
  {
    countryCode: "BY",
    tokens: "BY Belarus",
    value: "Belarus",
    name: "Belarus",
  },
  {
    countryCode: "BE",
    tokens: "BE Belgium",
    value: "Belgium",
    name: "Belgium",
  },
  { countryCode: "BZ", tokens: "BZ Belize", value: "Belize", name: "Belize" },
  { countryCode: "BJ", tokens: "BJ Benin", value: "Benin", name: "Benin" },
  {
    countryCode: "BM",
    tokens: "BM Bermuda",
    value: "Bermuda",
    name: "Bermuda",
  },
  { countryCode: "BT", tokens: "BT Bhutan", value: "Bhutan", name: "Bhutan" },
  {
    countryCode: "BO",
    tokens: "BO Bolivia",
    value: "Bolivia",
    name: "Bolivia",
  },
  {
    countryCode: "BA",
    tokens: "BA Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
    name: "Bosnia and Herzegovina",
  },
  {
    countryCode: "BW",
    tokens: "BW Botswana",
    value: "Botswana",
    name: "Botswana",
  },
  {
    countryCode: "BV",
    tokens: "BV Bouvet Island",
    value: "Bouvet Island",
    name: "Bouvet Island",
  },
  { countryCode: "BR", tokens: "BR Brazil", value: "Brazil", name: "Brazil" },
  {
    countryCode: "IO",
    tokens: "IO British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
    name: "British Indian Ocean Territory",
  },
  {
    countryCode: "BN",
    tokens: "BN Brunei Darussalam",
    value: "Brunei Darussalam",
    name: "Brunei Darussalam",
  },
  {
    countryCode: "BG",
    tokens: "BG Bulgaria",
    value: "Bulgaria",
    name: "Bulgaria",
  },
  {
    countryCode: "BF",
    tokens: "BF Burkina Faso",
    value: "Burkina Faso",
    name: "Burkina Faso",
  },
  {
    countryCode: "BI",
    tokens: "BI Burundi",
    value: "Burundi",
    name: "Burundi",
  },
  {
    countryCode: "KH",
    tokens: "KH Cambodia",
    value: "Cambodia",
    name: "Cambodia",
  },
  {
    countryCode: "CM",
    tokens: "CM Cameroon",
    value: "Cameroon",
    name: "Cameroon",
  },
  { countryCode: "CA", tokens: "CA Canada", value: "Canada", name: "Canada" },
  {
    countryCode: "CV",
    tokens: "CV Cape Verde",
    value: "Cape Verde",
    name: "Cape Verde",
  },
  {
    countryCode: "KY",
    tokens: "KY Cayman Islands",
    value: "Cayman Islands",
    name: "Cayman Islands",
  },
  {
    countryCode: "CF",
    tokens: "CF Central African Republic",
    value: "Central African Republic",
    name: "Central African Republic",
  },
  { countryCode: "TD", tokens: "TD Chad", value: "Chad", name: "Chad" },
  { countryCode: "CL", tokens: "CL Chile", value: "Chile", name: "Chile" },
  { countryCode: "CN", tokens: "CN China", value: "China", name: "China" },
  {
    countryCode: "CX",
    tokens: "CX Christmas Island",
    value: "Christmas Island",
    name: "Christmas Island",
  },
  {
    countryCode: "CC",
    tokens: "CC Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands",
    name: "Cocos (Keeling) Islands",
  },
  {
    countryCode: "CO",
    tokens: "CO Colombia",
    value: "Colombia",
    name: "Colombia",
  },
  {
    countryCode: "KM",
    tokens: "KM Comoros",
    value: "Comoros",
    name: "Comoros",
  },
  { countryCode: "CG", tokens: "CG Congo", value: "Congo", name: "Congo" },
  {
    countryCode: "CD",
    tokens: "CD Congo, The Democratic Republic of the",
    value: "Congo, The Democratic Republic of the",
    name: "Congo, The Democratic Republic of the",
  },
  {
    countryCode: "DO",
    tokens: "DO Dominican Republic",
    value: "Dominican Republic",
    name: "Dominican Republic",
  },
  {
    countryCode: "EC",
    tokens: "EC Ecuador",
    value: "Ecuador",
    name: "Ecuador",
  },
  {
    countryCode: "EG",
    tokens: "EG Egypt",
    value: "Egypt",
    name: "Egypt",
  },
  {
    countryCode: "SV",
    tokens: "SV El Salvador",
    value: "El Salvador",
    name: "El Salvador",
  },
  {
    countryCode: "GQ",
    tokens: "GQ Equatorial Guinea",
    value: "Equatorial Guinea",
    name: "Equatorial Guinea",
  },
  {
    countryCode: "ER",
    tokens: "ER Eritrea",
    value: "Eritrea",
    name: "Eritrea",
  },
  {
    countryCode: "EE",
    tokens: "EE Estonia",
    value: "Estonia",
    name: "Estonia",
  },
  {
    countryCode: "ET",
    tokens: "ET Ethiopia",
    value: "Ethiopia",
    name: "Ethiopia",
  },
  {
    countryCode: "FK",
    tokens: "FK Falkland Islands (Malvinas)",
    value: "Falkland Islands (Malvinas)",
    name: "Falkland Islands (Malvinas)",
  },
  {
    countryCode: "FO",
    tokens: "FO Faroe Islands",
    value: "Faroe Islands",
    name: "Faroe Islands",
  },
  {
    countryCode: "FJ",
    tokens: "FJ Fiji",
    value: "Fiji",
    name: "Fiji",
  },
  {
    countryCode: "FI",
    tokens: "FI Finland",
    value: "Finland",
    name: "Finland",
  },
  {
    countryCode: "FR",
    tokens: "FR France",
    value: "France",
    name: "France",
  },
  {
    countryCode: "GF",
    tokens: "GF French Guiana",
    value: "French Guiana",
    name: "French Guiana",
  },
  {
    countryCode: "PF",
    tokens: "PF French Polynesia",
    value: "French Polynesia",
    name: "French Polynesia",
  },
  {
    countryCode: "TF",
    tokens: "TF French Southern Territories",
    value: "French Southern Territories",
    name: "French Southern Territories",
  },
  {
    countryCode: "GA",
    tokens: "GA Gabon",
    value: "Gabon",
    name: "Gabon",
  },
  {
    countryCode: "GM",
    tokens: "GM Gambia",
    value: "Gambia",
    name: "Gambia",
  },
  {
    countryCode: "GE",
    tokens: "GE Georgia",
    value: "Georgia",
    name: "Georgia",
  },
  {
    countryCode: "DE",
    tokens: "DE Germany",
    value: "Germany",
    name: "Germany",
  },
  {
    countryCode: "GH",
    tokens: "GH Ghana",
    value: "Ghana",
    name: "Ghana",
  },
  {
    countryCode: "GI",
    tokens: "GI Gibraltar",
    value: "Gibraltar",
    name: "Gibraltar",
  },
  {
    countryCode: "GR",
    tokens: "GR Greece",
    value: "Greece",
    name: "Greece",
  },
  {
    countryCode: "GL",
    tokens: "GL Greenland",
    value: "Greenland",
    name: "Greenland",
  },
  {
    countryCode: "GD",
    tokens: "GD Grenada",
    value: "Grenada",
    name: "Grenada",
  },
  {
    countryCode: "GP",
    tokens: "GP Guadeloupe",
    value: "Guadeloupe",
    name: "Guadeloupe",
  },
  {
    countryCode: "GU",
    tokens: "GU Guam",
    value: "Guam",
    name: "Guam",
  },
  {
    countryCode: "GT",
    tokens: "GT Guatemala",
    value: "Guatemala",
    name: "Guatemala",
  },
  {
    countryCode: "GG",
    tokens: "GG Guernsey",
    value: "Guernsey",
    name: "Guernsey",
  },
  {
    countryCode: "GN",
    tokens: "GN Guinea",
    value: "Guinea",
    name: "Guinea",
  },
  {
    countryCode: "GW",
    tokens: "GW Guinea-Bissau",
    value: "Guinea-Bissau",
    name: "Guinea-Bissau",
  },
  {
    countryCode: "GY",
    tokens: "GY Guyana",
    value: "Guyana",
    name: "Guyana",
  },
  {
    countryCode: "HT",
    tokens: "HT Haiti",
    value: "Haiti",
    name: "Haiti",
  },
  {
    countryCode: "HM",
    tokens: "HM Heard Island and Mcdonald Islands",
    value: "Heard Island and Mcdonald Islands",
    name: "Heard Island and Mcdonald Islands",
  },
  {
    countryCode: "VA",
    tokens: "VA Holy See (Vatican City State)",
    value: "Holy See (Vatican City State)",
    name: "Holy See (Vatican City State)",
  },
  {
    countryCode: "HN",
    tokens: "HN Honduras",
    value: "Honduras",
    name: "Honduras",
  },
  {
    countryCode: "HK",
    tokens: "HK Hong Kong",
    value: "Hong Kong",
    name: "Hong Kong",
  },
  {
    countryCode: "HU",
    tokens: "HU Hungary",
    value: "Hungary",
    name: "Hungary",
  },
  {
    countryCode: "IS",
    tokens: "IS Iceland",
    value: "Iceland",
    name: "Iceland",
  },
  {
    countryCode: "IN",
    tokens: "IN India",
    value: "India",
    name: "India",
  },
  {
    countryCode: "ID",
    tokens: "ID Indonesia",
    value: "Indonesia",
    name: "Indonesia",
  },
  {
    countryCode: "IR",
    tokens: "IR Iran, Islamic Republic Of",
    value: "Iran, Islamic Republic Of",
    name: "Iran, Islamic Republic Of",
  },
  {
    countryCode: "IQ",
    tokens: "IQ Iraq",
    value: "Iraq",
    name: "Iraq",
  },
  {
    countryCode: "IE",
    tokens: "IE Ireland",
    value: "Ireland",
    name: "Ireland",
  },
  {
    countryCode: "IM",
    tokens: "IM Isle of Man",
    value: "Isle of Man",
    name: "Isle of Man",
  },
  {
    countryCode: "IL",
    tokens: "IL Israel",
    value: "Israel",
    name: "Israel",
  },
  {
    countryCode: "IT",
    tokens: "IT Italy",
    value: "Italy",
    name: "Italy",
  },
  {
    countryCode: "JM",
    tokens: "JM Jamaica",
    value: "Jamaica",
    name: "Jamaica",
  },
  {
    countryCode: "JP",
    tokens: "JP Japan",
    value: "Japan",
    name: "Japan",
  },
  { countryCode: "OM", tokens: "OM Oman", value: "Oman", name: "Oman" },
  {
    countryCode: "PK",
    tokens: "PK Pakistan",
    value: "Pakistan",
    name: "Pakistan",
  },
  { countryCode: "PW", tokens: "PW Palau", value: "Palau", name: "Palau" },
  {
    countryCode: "PS",
    tokens: "PS Palestinian Territory, Occupied",
    value: "Palestinian Territory, Occupied",
    name: "Palestinian Territory, Occupied",
  },
  { countryCode: "PA", tokens: "PA Panama", value: "Panama", name: "Panama" },
  {
    countryCode: "PG",
    tokens: "PG Papua New Guinea",
    value: "Papua New Guinea",
    name: "Papua New Guinea",
  },
  {
    countryCode: "PY",
    tokens: "PY Paraguay",
    value: "Paraguay",
    name: "Paraguay",
  },
  { countryCode: "PE", tokens: "PE Peru", value: "Peru", name: "Peru" },
  {
    countryCode: "PH",
    tokens: "PH Philippines",
    value: "Philippines",
    name: "Philippines",
  },
  {
    countryCode: "PN",
    tokens: "PN Pitcairn",
    value: "Pitcairn",
    name: "Pitcairn",
  },
  { countryCode: "PL", tokens: "PL Poland", value: "Poland", name: "Poland" },
  {
    countryCode: "PT",
    tokens: "PT Portugal",
    value: "Portugal",
    name: "Portugal",
  },
  {
    countryCode: "PR",
    tokens: "PR Puerto Rico",
    value: "Puerto Rico",
    name: "Puerto Rico",
  },
  { countryCode: "QA", tokens: "QA Qatar", value: "Qatar", name: "Qatar" },
  {
    countryCode: "RE",
    tokens: "RE Reunion",
    value: "Reunion",
    name: "Reunion",
  },
  {
    countryCode: "RO",
    tokens: "RO Romania",
    value: "Romania",
    name: "Romania",
  },
  {
    countryCode: "RU",
    tokens: "RU Russian Federation",
    value: "Russian Federation",
    name: "Russian Federation",
  },
  { countryCode: "RW", tokens: "RW RWANDA", value: "RWANDA", name: "RWANDA" },
  {
    countryCode: "SH",
    tokens: "SH Saint Helena",
    value: "Saint Helena",
    name: "Saint Helena",
  },
  {
    countryCode: "KN",
    tokens: "KN Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
    name: "Saint Kitts and Nevis",
  },
  {
    countryCode: "LC",
    tokens: "LC Saint Lucia",
    value: "Saint Lucia",
    name: "Saint Lucia",
  },
  {
    countryCode: "PM",
    tokens: "PM Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon",
    name: "Saint Pierre and Miquelon",
  },
  {
    countryCode: "VC",
    tokens: "VC Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
    name: "Saint Vincent and the Grenadines",
  },
  { countryCode: "WS", tokens: "WS Samoa", value: "Samoa", name: "Samoa" },
  {
    countryCode: "SM",
    tokens: "SM San Marino",
    value: "San Marino",
    name: "San Marino",
  },
  {
    countryCode: "ST",
    tokens: "ST Sao Tome and Principe",
    value: "Sao Tome and Principe",
    name: "Sao Tome and Principe",
  },
  {
    countryCode: "SA",
    tokens: "SA Saudi Arabia",
    value: "Saudi Arabia",
    name: "Saudi Arabia",
  },
  {
    countryCode: "SN",
    tokens: "SN Senegal",
    value: "Senegal",
    name: "Senegal",
  },
  { countryCode: "RS", tokens: "RS Serbia", value: "Serbia", name: "Serbia" },
  {
    countryCode: "ME",
    tokens: "ME Montenegro",
    value: "Montenegro",
    name: "Montenegro",
  },
  {
    countryCode: "SC",
    tokens: "SC Seychelles",
    value: "Seychelles",
    name: "Seychelles",
  },
  {
    countryCode: "SL",
    tokens: "SL Sierra Leone",
    value: "Sierra Leone",
    name: "Sierra Leone",
  },
  {
    countryCode: "SG",
    tokens: "SG Singapore",
    value: "Singapore",
    name: "Singapore",
  },
  {
    countryCode: "SK",
    tokens: "SK Slovakia",
    value: "Slovakia",
    name: "Slovakia",
  },
  {
    countryCode: "SI",
    tokens: "SI Slovenia",
    value: "Slovenia",
    name: "Slovenia",
  },
  {
    countryCode: "SB",
    tokens: "SB Solomon Islands",
    value: "Solomon Islands",
    name: "Solomon Islands",
  },
  {
    countryCode: "SO",
    tokens: "SO Somalia",
    value: "Somalia",
    name: "Somalia",
  },
  {
    countryCode: "ZA",
    tokens: "ZA South Africa",
    value: "South Africa",
    name: "South Africa",
  },
  {
    countryCode: "GS",
    tokens: "GS South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
    name: "South Georgia and the South Sandwich Islands",
  },
  { countryCode: "ES", tokens: "ES Spain", value: "Spain", name: "Spain" },
  {
    countryCode: "LK",
    tokens: "LK Sri Lanka",
    value: "Sri Lanka",
    name: "Sri Lanka",
  },
  { countryCode: "SD", tokens: "SD Sudan", value: "Sudan", name: "Sudan" },
  {
    countryCode: "SR",
    tokens: "SR Suriname",
    value: "Suriname",
    name: "Suriname",
  },
  {
    countryCode: "SJ",
    tokens: "SJ Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen",
    name: "Svalbard and Jan Mayen",
  },
  {
    countryCode: "SZ",
    tokens: "SZ Swaziland",
    value: "Swaziland",
    name: "Swaziland",
  },
  { countryCode: "SE", tokens: "SE Sweden", value: "Sweden", name: "Sweden" },
  {
    countryCode: "CH",
    tokens: "CH Switzerland",
    value: "Switzerland",
    name: "Switzerland",
  },
  {
    countryCode: "SY",
    tokens: "SY Syrian Arab Republic",
    value: "Syrian Arab Republic",
    name: "Syrian Arab Republic",
  },

  {
    countryCode: "TW",
    tokens: "TW Taiwan, Province of China",
    value: "Taiwan, Province of China",
    name: "Taiwan, Province of China",
  },
  {
    countryCode: "TJ",
    tokens: "TJ Tajikistan",
    value: "Tajikistan",
    name: "Tajikistan",
  },
  {
    countryCode: "TZ",
    tokens: "TZ Tanzania, United Republic of",
    value: "Tanzania, United Republic of",
    name: "Tanzania, United Republic of",
  },
  {
    countryCode: "TH",
    tokens: "TH Thailand",
    value: "Thailand",
    name: "Thailand",
  },
  {
    countryCode: "TL",
    tokens: "TL Timor-Leste",
    value: "Timor-Leste",
    name: "Timor-Leste",
  },
  { countryCode: "TG", tokens: "TG Togo", value: "Togo", name: "Togo" },
  {
    countryCode: "TK",
    tokens: "TK Tokelau",
    value: "Tokelau",
    name: "Tokelau",
  },
  { countryCode: "TO", tokens: "TO Tonga", value: "Tonga", name: "Tonga" },
  {
    countryCode: "TT",
    tokens: "TT Trinidad and Tobago",
    value: "Trinidad and Tobago",
    name: "Trinidad and Tobago",
  },
  {
    countryCode: "TN",
    tokens: "TN Tunisia",
    value: "Tunisia",
    name: "Tunisia",
  },
  { countryCode: "TR", tokens: "TR Turkey", value: "Turkey", name: "Turkey" },
  {
    countryCode: "TM",
    tokens: "TM Turkmenistan",
    value: "Turkmenistan",
    name: "Turkmenistan",
  },
  {
    countryCode: "TC",
    tokens: "TC Turks and Caicos Islands",
    value: "Turks and Caicos Islands",
    name: "Turks and Caicos Islands",
  },
  { countryCode: "TV", tokens: "TV Tuvalu", value: "Tuvalu", name: "Tuvalu" },
  { countryCode: "UG", tokens: "UG Uganda", value: "Uganda", name: "Uganda" },
  {
    countryCode: "UA",
    tokens: "UA Ukraine",
    value: "Ukraine",
    name: "Ukraine",
  },
  {
    countryCode: "AE",
    tokens: "AE United Arab Emirates",
    value: "United Arab Emirates",
    name: "United Arab Emirates",
  },
  {
    countryCode: "GB",
    tokens: "GB United Kingdom",
    value: "United Kingdom",
    name: "United Kingdom",
  },
  {
    countryCode: "US",
    tokens: "US United States",
    value: "United States",
    name: "United States",
  },
  {
    countryCode: "UM",
    tokens: "UM United States Minor Outlying Islands",
    value: "United States Minor Outlying Islands",
    name: "United States Minor Outlying Islands",
  },
  {
    countryCode: "UY",
    tokens: "UY Uruguay",
    value: "Uruguay",
    name: "Uruguay",
  },
  {
    countryCode: "UZ",
    tokens: "UZ Uzbekistan",
    value: "Uzbekistan",
    name: "Uzbekistan",
  },
  {
    countryCode: "VU",
    tokens: "VU Vanuatu",
    value: "Vanuatu",
    name: "Vanuatu",
  },
  {
    countryCode: "VE",
    tokens: "VE Venezuela",
    value: "Venezuela",
    name: "Venezuela",
  },
  {
    countryCode: "VN",
    tokens: "VN Viet Nam",
    value: "Viet Nam",
    name: "Viet Nam",
  },
  {
    countryCode: "VG",
    tokens: "VG Virgin Islands, British",
    value: "Virgin Islands, British",
    name: "Virgin Islands, British",
  },
  {
    countryCode: "VI",
    tokens: "VI Virgin Islands, U.S.",
    value: "Virgin Islands, U.S.",
    name: "Virgin Islands, U.S.",
  },
  {
    countryCode: "WF",
    tokens: "WF Wallis and Futuna",
    value: "Wallis and Futuna",
    name: "Wallis and Futuna",
  },
  {
    countryCode: "EH",
    tokens: "EH Western Sahara",
    value: "Western Sahara",
    name: "Western Sahara",
  },
  { countryCode: "YE", tokens: "YE Yemen", value: "Yemen", name: "Yemen" },
  { countryCode: "ZM", tokens: "ZM Zambia", value: "Zambia", name: "Zambia" },
  {
    countryCode: "ZW",
    tokens: "ZW Zimbabwe",
    value: "Zimbabwe",
    name: "Zimbabwe",
  },
];

export const countryCodeList = [
  {
    code: "us",
    name: "United States",
    flag: "🇺🇸",
    dialCode: "+1",
    format: "(XXX) XXX-XXXX",
  },
  {
    code: "ca",
    name: "Canada",
    flag: "🇨🇦",
    dialCode: "+1",
    format: "(XXX) XXX-XXXX",
  },
  {
    code: "gb",
    name: "United Kingdom",
    flag: "🇬🇧",
    dialCode: "+44",
    format: "+44 XXXX XXXXXX",
  },
  {
    code: "au",
    name: "Australia",
    flag: "🇦🇺",
    dialCode: "+61",
    format: "+61 XXXX XXX XXX",
  },
  {
    code: "in",
    name: "India",
    flag: "🇮🇳",
    dialCode: "+91",
    format: "+91 XXXXX XXXXX",
  },
  {
    code: "fr",
    name: "France",
    flag: "🇫🇷",
    dialCode: "+33",
    format: "+33 X XX XX XX XX",
  },
  {
    code: "de",
    name: "Germany",
    flag: "🇩🇪",
    dialCode: "+49",
    format: "+49 XXXX XXXXX",
  },
  {
    code: "cn",
    name: "China",
    flag: "🇨🇳",
    dialCode: "+86",
    format: "+86 XXXX XXXX XXXX",
  },
  {
    code: "br",
    name: "Brazil",
    flag: "🇧🇷",
    dialCode: "+55",
    format: "+55 XX XXXX-XXXX",
  },
  {
    code: "za",
    name: "South Africa",
    flag: "🇿🇦",
    dialCode: "+27",
    format: "+27 XX XXX XXXX",
  },
  {
    code: "ru",
    name: "Russia",
    flag: "🇷🇺",
    dialCode: "+7",
    format: "+7 (XXX) XXX-XX-XX",
  },
  {
    code: "mx",
    name: "Mexico",
    flag: "🇲🇽",
    dialCode: "+52",
    format: "+52 XXX XXX XXXX",
  },
  {
    code: "jp",
    name: "Japan",
    flag: "🇯🇵",
    dialCode: "+81",
    format: "+81 XX-XXXX-XXXX",
  },
  {
    code: "it",
    name: "Italy",
    flag: "🇮🇹",
    dialCode: "+39",
    format: "+39 XXX XXX XXXX",
  },
  {
    code: "es",
    name: "Spain",
    flag: "🇪🇸",
    dialCode: "+34",
    format: "+34 XXX XXX XXX",
  },
  {
    code: "kr",
    name: "South Korea",
    flag: "🇰🇷",
    dialCode: "+82",
    format: "+82 XX-XXXX-XXXX",
  },
  {
    code: "tr",
    name: "Turkey",
    flag: "🇹🇷",
    dialCode: "+90",
    format: "+90 (XXX) XXX XX XX",
  },
  {
    code: "nl",
    name: "Netherlands",
    flag: "🇳🇱",
    dialCode: "+31",
    format: "+31 XX XXXXXXX",
  },
  {
    code: "ar",
    name: "Argentina",
    flag: "🇦🇷",
    dialCode: "+54",
    format: "+54 X XXXX-XXXX",
  },
  {
    code: "se",
    name: "Sweden",
    flag: "🇸🇪",
    dialCode: "+46",
    format: "+46 XX-XXX XX XX",
  },
  {
    code: "ch",
    name: "Switzerland",
    flag: "🇨🇭",
    dialCode: "+41",
    format: "+41 XX XXX XX XX",
  },
  {
    code: "pl",
    name: "Poland",
    flag: "🇵🇱",
    dialCode: "+48",
    format: "+48 XXX XXX XXX",
  },
  {
    code: "id",
    name: "Indonesia",
    flag: "🇮🇩",
    dialCode: "+62",
    format: "+62 XX-XXXX-XXXX",
  },
  {
    code: "sa",
    name: "Saudi Arabia",
    flag: "🇸🇦",
    dialCode: "+966",
    format: "+966 XX XXX XXXX",
  },
  {
    code: "ae",
    name: "United Arab Emirates",
    flag: "🇦🇪",
    dialCode: "+971",
    format: "+971 XX XXX XXXX",
  },
  {
    code: "th",
    name: "Thailand",
    flag: "🇹🇭",
    dialCode: "+66",
    format: "+66 XX-XXX-XXXX",
  },
  {
    code: "ng",
    name: "Nigeria",
    flag: "🇳🇬",
    dialCode: "+234",
    format: "+234 XXX XXX XXXX",
  },
  {
    code: "eg",
    name: "Egypt",
    flag: "🇪🇬",
    dialCode: "+20",
    format: "+20 XX XXX XXXX",
  },
  {
    code: "pk",
    name: "Pakistan",
    flag: "🇵🇰",
    dialCode: "+92",
    format: "+92 XXX XXX XXXX",
  },
  {
    code: "vn",
    name: "Vietnam",
    flag: "🇻🇳",
    dialCode: "+84",
    format: "+84 XX XXXX XXXX",
  },
  {
    code: "ph",
    name: "Philippines",
    flag: "🇵🇭",
    dialCode: "+63",
    format: "+63 XX XXXX XXXX",
  },
  {
    code: "bd",
    name: "Bangladesh",
    flag: "🇧🇩",
    dialCode: "+880",
    format: "+880 XXX-XXXXXXX",
  },
  {
    code: "my",
    name: "Malaysia",
    flag: "🇲🇾",
    dialCode: "+60",
    format: "+60 X-XXXX XXXX",
  },
  {
    code: "iq",
    name: "Iraq",
    flag: "🇮🇶",
    dialCode: "+964",
    format: "+964 XX XXX XXXX",
  },
  {
    code: "ir",
    name: "Iran",
    flag: "🇮🇷",
    dialCode: "+98",
    format: "+98 XX-XXXX-XXXX",
  },
  {
    code: "no",
    name: "Norway",
    flag: "🇳🇴",
    dialCode: "+47",
    format: "+47 XXX XX XXX",
  },
  {
    code: "dk",
    name: "Denmark",
    flag: "🇩🇰",
    dialCode: "+45",
    format: "+45 XX XX XX XX",
  },
  {
    code: "fi",
    name: "Finland",
    flag: "🇫🇮",
    dialCode: "+358",
    format: "+358 XX XXXX XXXX",
  },
  {
    code: "gr",
    name: "Greece",
    flag: "🇬🇷",
    dialCode: "+30",
    format: "+30 XX XXXX XXXX",
  },
  {
    code: "ie",
    name: "Ireland",
    flag: "🇮🇪",
    dialCode: "+353",
    format: "+353 XX XXX XXXX",
  },
  {
    code: "nz",
    name: "New Zealand",
    flag: "🇳🇿",
    dialCode: "+64",
    format: "+64 XX XXXX XXXX",
  },
  {
    code: "sg",
    name: "Singapore",
    flag: "🇸🇬",
    dialCode: "+65",
    format: "+65 XXXX XXXX",
  },
  {
    code: "pt",
    name: "Portugal",
    flag: "🇵🇹",
    dialCode: "+351",
    format: "+351 XX XXX XXXX",
  },
  {
    code: "cl",
    name: "Chile",
    flag: "🇨🇱",
    dialCode: "+56",
    format: "+56 X XXXX XXXX",
  },
  {
    code: "hu",
    name: "Hungary",
    flag: "🇭🇺",
    dialCode: "+36",
    format: "+36 XX XXX XXXX",
  },
  {
    code: "ro",
    name: "Romania",
    flag: "🇷🇴",
    dialCode: "+40",
    format: "+40 XX XXX XXXX",
  },
  {
    code: "cz",
    name: "Czech Republic",
    flag: "🇨🇿",
    dialCode: "+420",
    format: "+420 XXX XXX XXX",
  },
  {
    code: "il",
    name: "Israel",
    flag: "🇮🇱",
    dialCode: "+972",
    format: "+972 XX XXX XXXX",
  },
  {
    code: "hk",
    name: "Hong Kong",
    flag: "🇭🇰",
    dialCode: "+852",
    format: "+852 XXXX XXXX",
  },
];
